import styled from "styled-components";

export const RackSearchWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column;
  gap: 10px;

  .scanBtn {
    border: none;
    background-color: var(--accent);
    color: #fff;
    border-radius: 5px;
    padding: 0 10px;
    width: 100%;
    min-height: 40px;
  }
`;
